import combineReducers from '../utils/combineReducers';
import ads from './ads';
import analytics from './analytics';
import api from './api';
import article from './article';
import i18n from './i18n';
import meta from './meta';
import modules from './modules';
import navigation from './navigation';
import product from './product';
import productList from './productList';
import series from './series';
import upNext from './up_next';
import shoppingNavigation from './shoppingNavigation';
import trendingItems from './trendingItems';
import experiments from './experiments';

const rootReducer = combineReducers({
  /*
   * Active reducers: typical Redux reducers that respond to actions and change
   * the state through the lifecycle of the application.
   */
  ads,
  analytics,
  api,
  article,
  i18n,
  meta,
  modules,
  navigation,
  product,
  productList,
  series,
  upNext,
  shoppingNavigation,
  trendingItems,
  experiments,
  /*
   * Inert reducers: reducers that never respond to actions and therefore never
   * modify the Redux state, and are only in the store because it is an
   * effective way to pass data from server to client. Their state is populated
   * in `configureStore.js` on bootstrap.
   */
  cookies: (state = {}) => state,
  isPreviewPage: (state = false) => state,
  ui: (state = {}) => state,
  wordpressApiHost: (state = null) => state
});

export default rootReducer;
